/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Col, FormLabel} from 'react-bootstrap';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";

import * as fieldComponents from "../../../Models/Core/FieldComponents";

// @PermissionCheckerEnhance
export const ProjectContactRelationshipsModelViewerRecordRenderer = (props) => {
    
    const {
        Data,
        EditMode,
        FieldDef: fieldDef,
        FieldDefinitionGroups = null,
        IsNewModel,
        OnValidationUpdate,
        RootData,
        Validation
    } = props;

    const {
        getFieldDefs,
        updateField,
        updateFields,
        sortFieldDefs,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const EditorComponent = fieldComponents?.[fieldDef.editor] ?? null;
    const ViewerComponent = fieldComponents?.[fieldDef.viewer] ?? null;

    if(EditorComponent == null || ViewerComponent == null) {
        return null;
    }
    
    return <Col xs={6} className={"sb-editor-row-" + fieldDef.key}>
        {
            fieldDef.displayLabel ?
                <FormLabel>
                    {fieldDef.title}
                </FormLabel> :
                null
        }
        <div className="sb-model-viewer-column">
            {
                EditMode ?
                    <EditorComponent
                        Value={fieldDef.getter(Data)}
                        OnUpdate={(y) => updateField(fieldDef, y)}
                        FieldDef={fieldDef}
                        RootData={RootData}
                        Data={Data}
                        FieldDefs={FieldDefinitionGroups ?? getFieldDefs(true)}
                        OnValidationUpdate={OnValidationUpdate}
                        IsNewModel={IsNewModel}
                    /> :
                    <ViewerComponent
                        Value={fieldDef.getter(Data)}
                        FieldDef={fieldDef}
                        RootData={RootData}
                        Data={Data}
                        FieldDefs={FieldDefinitionGroups ?? getFieldDefs(true)}
                        OnValidationUpdate={OnValidationUpdate}
                        IsNewModel={IsNewModel}
                    />
            }
            {
                Validation && !Validation.valid ?
                    <span className="sb-model-viewer-validation-failure-text-small">
                            {Validation.message}
                        </span> :
                    null
            }
        </div>
    </Col>;
};


